import { IFareDetail } from 'list/international/types';

export type ICardFareTypeMap = {
  all?: boolean;
  [key: string]: boolean | undefined;
};

export enum AgreementStatus {
  AGREED = 'AGREED',
  EXPIRED = 'EXPIRED',
  NOT_AGREED = 'NOT_AGREED',
  NOT_CONFIRMED = 'NOT_CONFIRMED',
  NOT_LOGGED_IN = 'NOT_LOGGED_IN',
}

export enum OtaType {
  KR_OTA = 'KR_OTA',
  GLOBAL_OTA = 'GLOBAL_OTA',
  KR_AIRLINE = 'KR_AIRLINE',
  GLOBAL_AIRLINE = 'GLOBAL_AIRLINE',
}

export enum AmenityAvailability {
  CHARGEABLE = 'CHARGEABLE',
  EXCLUDED = 'EXCLUDED',
  INCLUDED = 'INCLUDED',
}

export interface IBookingParams {
  airlineCode: string;
  fitName: string;
  depCity: string;
  arrCity: string;
  departureDateTime: string;
  arrivalDateTime: string;
  seatClass: string;
  etc: string;
  seatCnt: number;
  stops: number;
  adultFare: number;
  childFare: number;
  infantFare: number;
  aFuel: number;
  cFuel: number;
  iFuel: number;
  aTax: number;
  cTax: number;
  iTax: number;
  publishFee: number;
}

export interface IOta {
  otaId: string;
  expName: string;
  fare: number;
  fareType: string;
  bookingUrl: string;
  supportNPay: boolean;
  supportNaverLogin?: boolean;
  otaType?: OtaType;
  isCsCenter?: boolean;
  isCsCenterEmail?: boolean;
  isKoreanWebsite?: boolean;
  agreeStatus: AgreementStatus;
  csInfo?: {
    active?: boolean;
    phone1?: string;
    phone2?: string;
    businessHour?: string;
    lunchTime?: string;
    is365Days?: boolean;
    email?: string;
    online?: string;
    otherContactInfo?: string;
  };
  caution?: string;
  adText?: string;
  active?: {
    ad?: boolean;
    mypage?: boolean;
    realtime?: boolean;
  };
  refundPolicy?: {
    isFreeSameDayRefundable?: boolean;
    // otaCommissionRefundable?: boolean;
    // refundableDuringWeekend?: boolean;
    // refundableTime?: string;
    // refundPolicyUrl?: string;
  };
}

export interface IBookingOptions {
  bookingOptions: { combined: IOta[]; otaList: IOta[] };
}

export interface IPassengerCount {
  adultCnt: number;
  childCnt: number;
  infantCnt: number;
}

export interface IOtaFareList {
  ota: IOta;
  fare: IFareDetail;
}

export interface IItin {
  airlineCd: string;
  airlineName: string;
  arrAp: string;
  arrDt: string;
  arrTm: string;
  dayCnt: number;
  depAp: string;
  depDt: string;
  depTm: string;
  jrnyTm: string;
  viaCnt: number;
}

export interface IFlightData {
  fare: number;
  fareTp: string | null;
  itin: IItin[];
  seatSt: string;
  serviceUrl: string;
}

export interface IGroupParam {
  adultCnt: number;
  childCnt: number;
  infantCnt: number;
  airports: string[];
  cities: string[];
  fareTp: string;
  sdates: string[];
  ticketTp: string;
  tripTp: string;
}

interface IExtraImage {
  imageFileName: string;
}

interface IExtraContent {
  equipmentDesc: string;
  inFlightEntertainment?: AmenityAvailability;
  inFlightMealImages: IExtraImage[];
  insideImages: IExtraImage[];
  outsideImages: IExtraImage[];
  mealsAndBeverages?: AmenityAvailability;
  seatArrangement: string;
  seatInfo: string;
  usb?: AmenityAvailability;
  wiFi?: AmenityAvailability;
}
export interface IExtraContentList {
  extraContent: IExtraContent[];
}

interface IExtraConvertedImage {
  ImageFileName: string;
  type: string;
}
interface IExtraConvertedContent extends IExtraContent {
  InFlightMealImages: IExtraConvertedImage[];
  InsideImages: IExtraConvertedImage[];
  OutsideImages: IExtraConvertedImage[];
  photo: IExtraConvertedImage[];
  existContent: boolean;
}
export interface IExtraContentInfo {
  extraIcons: {
    MealsAndBeverages: boolean;
    InFlightEntertainment: boolean;
    WiFi: boolean;
    USB: boolean;
  };
  extraList: IExtraConvertedContent[];
}

export interface ICardFareTypeItem {
  key: string;
  otaId: string;
  price: number;
  fareDetail: IFareDetail;
  naverFare: number;
  hasTravelClubFare: boolean;
}
